import { InvoiceApi } from "../apis";
import { saveFile } from "./save-file";

/** "Select all matching" loads at most this many rows in one request. */
export const SELECT_ALL_CAP = 500;

/** Save each invoice's PDF in turn; returns how many failed. */
export async function saveInvoicePdfs(rows: { id?: string | null; refCode?: string | null }[]): Promise<number> {
  let failed = 0;
  for (const row of rows) {
    if (!row?.id) continue;
    try {
      const url: string = await InvoiceApi.pdf(row.id);
      await saveFile(url, `${row.refCode || row.id}.pdf`);
    } catch {
      failed += 1;
    }
  }
  return failed;
}
